module.exports = new __parcel__URL__("chtilug.3f33fb35.avif").toString();